
import { Component } from 'react'
import './index.css'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import { Examinee } from '../../../../../../../api/sennotech/scanner/v2/examinee'

interface StateProps {
    examinee: Examinee,
    createTime: string,
    title: string
    logo?: string
}

class Index extends Component<StateProps & WithTranslationProps> {

    render() {

        let examinee = this.props.examinee;
        let createTime = this.props.createTime;
        let ageStr = '';
        let nowDate = new Date();
        if (examinee.birthTime) {
            let birthTimestamp = (new Date(examinee.birthTime as any)).valueOf();
            if(birthTimestamp > 0) {
                let diff = nowDate.getTime() - birthTimestamp;
                let age = Math.floor(diff / 1000 / 60 / 60 / 24 / 365);
                if(age > 0) {
                    ageStr = age.toString();
                }
            }
            
        }

        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }

        let contactWay = '';
        if (examinee.mobileNumber) {
            contactWay = examinee.mobileNumber;
        }
        else if (examinee.email) {
            contactWay = examinee.email;
        }
        let genderStr = "";
        const gender = examinee.gender as any;
        if (gender == "FEMALE") {
            genderStr = i18n.t('female');
        }
        else if (gender == "MALE") {
            genderStr = i18n.t('male');
        }

        return (
            <div className="scanReportCom-customerInfo">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <th>{i18n.t('name')}</th>
                                <td>{examinee.nickname}</td>
                                <th>{i18n.t('gender')}</th>
                                <td>{genderStr}</td>
                                <th className='width-3'>{i18n.t('height')}(cm)</th>
                                <td>{examinee.height ? examinee.height : ""}</td>
                                <th className='width-4'>{i18n.t('contactWay')}</th>
                                {
                                    examinee.mobileNumber && examinee.email ?
                                    <td>{examinee.mobileNumber} / {examinee.email}</td> :
                                    <td>{examinee.mobileNumber || examinee.email}</td>
                                }
                                
                            </tr>
                            <tr>
                                <th>{i18n.t('remark')}</th>
                                <td>{examinee.description}</td>
                                <th>{i18n.t('age')}</th>
                                <td>{ageStr}</td>
                                <th className='width-3'>{i18n.t('weight')}(kg)</th>
                                <td>{examinee.weight ? examinee.weight : ""}</td>
                                <th className='width-4'>{i18n.t('detectionTime')}</th>
                                <td>{createTime}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Index)